import React from 'react'
import { Button } from '@material-ui/core'
import { appButtonStyles } from './style'

const AppButton = (props) => {
  const classes = appButtonStyles()

  let {
    text,
    fill,
    disabled
  } = props

  return <>
    <Button
      {...props}
      disableRipple
      disableFocusRipple
      className={classes.ButtonBox + (fill ? '' : (' ' + classes.PlainButtonBox)) + (` ${props.className}` || '') + (disabled ? ` ${classes.disable}` : '')}
      style={{minHeight: props.minHeight || '48px'}}
    >
      {text}
    </Button>
  </>
}

AppButton.defaultProps = {
  text: "",
  fill: true
}

export default AppButton